export const getCouriersColumns = () => {
  return [
    {
      'Header': 'COMPAÑÍA',
      'accessor': 'name',
      'width': '4',
    },
    {
      'Header': 'RUC',
      'accessor': 'ruc',
      'width': '2',
    },
    {
      'Header': 'DIRECCIÓN',
      'accessor': 'address',
      'width': '4',
    },
    {
      'Header': 'TELEFONO',
      'accessor': 'phone',
      'width': '1',
    },
  ];
};
